export const HOME = "/";
export const CITY_INFO = "/city-info";
